import Vue from 'vue';
import vueSocial from 'vue-social-sharing';
/** https://github.com/nicolasbeauvais/vue-social-sharing */
Vue.use(vueSocial)
